/**
 * Environment Configuration
 * 
 * ساده‌شده برای استفاده با Runtime Config
 * BASE_URL از config.json میاد که توسط ConfigMap تنظیم میشه
 */

import { getServiceUrls, getBaseUrl, getConfig, loadConfig } from './runtime-config';

// Re-export runtime config functions
export { loadConfig, getConfig, getBaseUrl, getServiceUrls };

// ============================================================================
// TYPES
// ============================================================================

export type Platform = 'web' | 'mobile';

export interface ServiceUrls {
  USER_SERVICE: string;
  BOOK_SERVICE: string;
  PAYMENT_SERVICE: string;
  AI_SERVICE: string;
  GAMIFICATION_SERVICE: string;
}

// ============================================================================
// PLATFORM DETECTION
// ============================================================================

/**
 * Detect if running on native mobile platform (Capacitor)
 */
export const isNative = (): boolean => {
  return typeof window !== 'undefined' && (window as any).Capacitor?.isNativePlatform?.() === true;
};

/**
 * Detect if running on web platform
 */
export const isWeb = (): boolean => !isNative();

/**
 * Get current platform
 */
export const getPlatform = (): Platform => isNative() ? 'mobile' : 'web';

// ============================================================================
// ENVIRONMENT DETECTION
// ============================================================================

/**
 * Check if in development mode
 */
export const isDevelopment = (): boolean => import.meta.env.DEV;

/**
 * Check if in production mode
 */
export const isProduction = (): boolean => import.meta.env.PROD;

// ============================================================================
// EXPORTED CONFIGURATION (Backward Compatibility)
// ============================================================================

/**
 * Current platform
 */
export const PLATFORM = getPlatform();

/**
 * Service URLs - uses runtime config
 * Note: These are getters that read from runtime config
 */
export const API_URLS = {
  get USER_SERVICE() { return getServiceUrls().USER_SERVICE; },
  get BOOK_SERVICE() { return getServiceUrls().BOOK_SERVICE; },
  get LEARNING_SERVICE() { return getServiceUrls().PAYMENT_SERVICE; }, // backward compatibility
  get LEAGUE_SERVICE() { return getServiceUrls().AI_SERVICE; }, // backward compatibility
  get GAMIFICATION_SERVICE() { return getServiceUrls().GAMIFICATION_SERVICE; },
  get PAYMENT_SERVICE() { return getServiceUrls().PAYMENT_SERVICE; },
  get AI_SERVICE() { return getServiceUrls().AI_SERVICE; },
};

/**
 * Base API URL (backward compatibility)
 */
export const API_BASE_URL = API_URLS.USER_SERVICE;
